import { borderColor, primaryColor } from '@/styles/variants';
import { Checkbox } from '@arco-design/web-react';
import { IconCheck } from '@arco-design/web-react/icon';
import React from 'react';
import styled from 'styled-components';

interface CheckboxOptionsProps {
  /** 选中的值 */
  selected?: string[];
  /** 变化时的回调 */
  onChange?: (selected: string[]) => void;
  /** 选项 */
  options?: { label: string; value: string }[];
}

export function CheckboxOptions({ selected, onChange, options }: CheckboxOptionsProps) {
  return (
    <>
      <Checkbox.Group
        value={selected}
        onChange={onChange}
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      >
        {options?.map((item) => (
          <>
            <Checkbox key={item.label} value={item.value}>
              {({ checked }) => {
                return (
                  <CheckboxItem $checked={checked}>
                    <CheckMask $checked={checked}>
                      <IconCheck />
                    </CheckMask>
                    {item.label}
                  </CheckboxItem>
                );
              }}
            </Checkbox>
          </>
        ))}
      </Checkbox.Group>
    </>
  );
}

/** ============================ 样式 ==================================== */
const CheckboxItem = styled.div<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid transparent;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.1s;
  &:hover {
    border-color: ${primaryColor};
  }
`;

const CheckMask = styled.div<{ $checked: boolean }>`
  width: 1.2rem;
  height: 1.2rem;
  background-color: ${({ $checked }) => ($checked ? `${primaryColor}` : 'transparent')};
  border-radius: 4px;
  border: ${({ $checked }) =>
    $checked ? `1px solid ${primaryColor}` : `1px solid ${borderColor}`};
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: #fff;
    width: 1rem;
    height: 1rem;
  }
  transition:
    background-color 0.1s,
    border 0.1s;
`;
